import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Header from './components/common/Header';
import Sidebar from './components/common/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import CreateProduct from './pages/CreateProduct';
import EditProduct from './pages/EditProduct';
import Categories from './pages/Categories';
import CreateCategory from './pages/CreateCategory';
import EditCategory from './pages/EditCategory';
import Campaigns from './pages/Campaigns';
import CreateCampaign from './pages/CreateCampaign';
import EditCampaign from './pages/EditCampaign';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import Reviews from './pages/Reviews';
import Users from './pages/Users';
import DashboardManager from './pages/DashboardManager';
import SupportSettings from './pages/SupportSettings';
import Settings from './pages/Settings';
import SupportRequests from './pages/SupportRequests';
import ShippingZones from './pages/ShippingZones';
import NotFound from './pages/NotFound';
import './App.css';

const AppLayout = ({ children }) => {
  return (
    <div className="app-layout">
      <Header />
      <div className="app-body">
        <Sidebar />
        <main className="app-main">{children}</main>
      </div>
    </div>
  );
};

const AppRoutes = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Dashboard />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Products />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/create"
        element={
          <ProtectedRoute>
            <AppLayout>
              <CreateProduct />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/edit/:productId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <EditProduct />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Categories />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories/create"
        element={
          <ProtectedRoute>
            <AppLayout>
              <CreateCategory />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories/edit/:categoryId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <EditCategory />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaigns"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Campaigns />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaigns/create"
        element={
          <ProtectedRoute>
            <AppLayout>
              <CreateCampaign />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/campaigns/edit/:campaignId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <EditCampaign />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Orders />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/orders/:orderId"
        element={
          <ProtectedRoute>
            <AppLayout>
              <OrderDetail />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/reviews"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Reviews />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Users />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard-manager"
        element={
          <ProtectedRoute>
            <AppLayout>
              <DashboardManager />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <AppLayout>
              <Settings />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/support-settings"
        element={
          <ProtectedRoute>
            <AppLayout>
              <SupportSettings />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/support-requests"
        element={
          <ProtectedRoute>
            <AppLayout>
              <SupportRequests />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/shipping-zones"
        element={
          <ProtectedRoute>
            <AppLayout>
              <ShippingZones />
            </AppLayout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
